<template>
  <div class="homepage-ships">
    <div class="main-title">
      <h2 class="title">皇家游轮体验</h2>
      <h3 class="subtitle"><span>26</span>艘海上移动城堡</h3>
    </div>

    <div class="ship-nav is-full">
      <ul class="main-nav">
        <template v-for="(item, i) in ships">
          <li v-if="item.id === 3 || item.id === 7"
              :key="i"
              :class="{ active: i == currentShipIndex }"
              :data-shipid="item.id"
              @click="changeShipIndex(i, item.shipCode)"
          >
            <div class="ship-name">
              <span class="ship-new" v-if="item.tagName == 'NEW'"></span>
              <span class="ship-hot" v-else-if="item.tagName == 'HOT'"></span>
              <span v-else></span>
              <span>{{ item.shipCNName }}</span>
            </div>
            <img class="font1-img" :src="item.shipENImage" alt="" />
            <img class="font2-img" :src="item.shipENImageSelected" alt="" />
          </li>
        </template>
      </ul>
    </div>
    <!--    <div class="ship-nav-banner">-->
    <!--      <img src="https://resource.rcclchina.com.cn/Home/home_banner_SC.jpg" />-->
    <!--    </div>-->
    <div class="main-experience">
      <div
          v-for="(ship, i) in ships"
          :key="i"
          class="super-exper"
          :class="{ active: i == currentShipIndex }"
      >
        <!--        <img-->
        <!--          class="exper-nav"-->
        <!--          :src="ship.pcBacKgroundImage"-->
        <!--          @click="showVideoModal(ship.pcVideo, ship.shipCode)"-->
        <!--        />-->
        <ul class="exper-list" v-if="ship.id === 3 || ship.id === 7">
          <li
              v-for="(experienceItem, j) in getExperienceItemsByShipId(ship.id)"
              :key="j"
              :class="{ active: j == currentItemIndex }"
              :data-releVanceShipId="experienceItem.shipId"
              @mouseenter="onExperienceItemMouseEnter(j)"
          >
            <div class="exper-mask" :class="{ active: currentItemIndex == j }">
              {{ experienceItem.title }}
            </div>
            <img :src="experienceItem.pcImage" alt="" />

            <div class="content">
              <div class="title">{{ experienceItem.title }}</div>
              <div class="border-line"></div>
              <div class="detail">
                <div class="parah" v-html="experienceItem.subTitle"></div>
                <a
                    class="a-btn"
                    v-if="experienceItem.pcLink && experienceItem.pcLink.length > 0"
                    :href="experienceItem.pcLink"
                    @click="goToShipPage(experienceItem.pcLink, experienceItem.code, ship.shipCode)"
                    target="_blank"
                >查看详情</a
                >
                <a v-else class="f-dn"></a>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <a class="link-btn f-dn">全部船队&nbsp;&nbsp;></a>
    </div>

    <VideoModel
        :isShow="isShowVideo"
        :videoUrl="selectVideoUrl"
        v-on:onModalClose="videoModalClose"
    />
  </div>
</template>


<script>
import _ from "lodash";
import { gioAdsTracking } from "@/utilities/tools";
const VideoModel = () => import("@/components/Common/VideoModel");
export default {
  name: "RoyalShip",
  components: {
    VideoModel,
  },
  props: {
    homeShip: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      shipExperienceIds: [],
      currentShipIndex: 0,
      currentItemIndex: 0,
      selectVideoUrl: "",
      isShowVideo: false,
    };
  },
  methods: {
    getExperienceItemsByShipId(shipId) {
      let experienceItems = this.homeShip.homeExperienceItemViewModels.filter(
          (r) => r.shipId == shipId
      );
      experienceItems = _.orderBy(experienceItems, "seq", "asc");
      return experienceItems;
    },
    changeShipIndex(index, shipCode) {
      this.currentShipIndex = index;
      gioAdsTracking({
        "adsType": "sp",
        "spCode": shipCode
      });
    },
    onExperienceItemMouseEnter(index) {
      this.currentItemIndex = index;
    },
    goToShipPage(link, expCode, shipCode) {
      gioAdsTracking({
        "adsType": "sp",
        "spCode": shipCode,
        "spCat": expCode,
        "desUrl": process.env.VUE_APP_BASE_URL + link
      });
      window.location.href = process.env.VUE_APP_BASE_URL + link;
    },
    showVideoModal(videoUrl, shipCode) {
      if (videoUrl && videoUrl.length > 0) {
        this.selectVideoUrl = videoUrl;
        this.isShowVideo = true;
        gioAdsTracking({
          "adsType": "sp",
          "spCode": shipCode,
          "spVideo": 1
        });
      }
    },
    videoModalClose() {
      this.isShowVideo = false;
      this.selectVideoUrl = "";
    },
  },
  computed: {
    ships() {
      return this.homeShip.homeRoyalShipItemViewModels;
    },
  },
};
</script>

<style scoped>
.ship-nav-banner {
  min-width: 240px;
  max-width: 1200px;
  margin: 0 auto 6px;
}
.ship-nav-banner > img {
  width: 100%;
  display: block;
}
</style>
